import { Star, ArrowUpRight, CalendarDays } from "lucide-react";
import { formatINR } from "../lib/api";
import { departureLabel, durationLabel } from "../data/packages";

export default function PackageCard({ pkg, onOpen, testid }) {
  return (
    <article
      data-testid={testid}
      onClick={() => onOpen(pkg)}
      className="group relative cursor-pointer overflow-hidden rounded-3xl border border-white/10 bg-obsidian transition-all duration-500 hover:-translate-y-1.5 hover:border-aurora/40 hover:shadow-[0_20px_60px_rgba(0,245,212,0.12)]"
    >
      <div className="relative h-52 overflow-hidden md:h-56">
        <img
          src={pkg.image}
          alt={pkg.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-transparent" />
        <span className="glass absolute left-4 top-4 rounded-full px-3 py-1.5 font-mono text-[10px] tracking-[0.18em] text-slate-100">
          {durationLabel(pkg)}
        </span>
        {pkg.rating && (
          <span className="glass absolute right-4 top-4 flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold text-comet">
            <Star className="h-3 w-3 fill-comet" /> {pkg.rating}
          </span>
        )}
      </div>
      <div className="p-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-aurora/90">{pkg.region}</p>
        <h3 className="mt-2 font-display text-xl font-bold tracking-tight text-slate-50">{pkg.name}</h3>
        <p className="mt-2 min-h-[3.4rem] text-sm leading-relaxed text-slate-400">{pkg.tagline}</p>
        <p className="mt-3 flex items-center gap-2 text-xs font-semibold text-aurora" data-testid="package-departure">
          <CalendarDays className="h-3.5 w-3.5" /> Departs every {departureLabel(pkg)}
        </p>
        <div className="mt-5 flex items-center justify-between border-t border-white/5 pt-4">
          <div>
            <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-slate-500">From</p>
            <p className="font-display text-lg font-bold text-slate-50">
              {formatINR(pkg.price)}
              <span className="font-body text-xs font-normal text-slate-500"> /person</span>
            </p>
          </div>
          <button
            data-testid={`${testid}-details-btn`}
            className="flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2 text-xs font-semibold text-slate-200 transition-all duration-300 group-hover:border-aurora/60 group-hover:text-aurora"
          >
            View Details <ArrowUpRight className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </article>
  );
}
